import {Component, ViewChild} from '@angular/core';
import {
  AlertController,
  Content,
  Events,
  MenuController, ModalController,
  NavController,
  NavParams,
  ToastController
} from "ionic-angular";
import {ApplicationVariables, Constants, IMAGES_BASE_URL} from "../../providers/config";
import {StockcartManager} from "../../providers/stockcart-manager";
import {Headers, Http, RequestOptions} from "@angular/http";
import {Api} from "../../providers/api";
import {CustomerCarts} from "../../providers/user-cart-provider/user-carts";
import {GVLogger} from "../../services/gv-logger";
import {MsgManager} from "../../providers/msg-manager";
import {ApiOffline} from "../../providers/api-offline";
import {Storage} from "@ionic/storage";
import {File} from "@ionic-native/file";
import {CartManager} from "../../providers/cart-manager";
import {RECEIVESTOCKLOCATION, REFERENCE, BADSTOCKCART, loginUserInfo} from "../../providers/data";
import {ReferenceListPage} from "../reference-list/reference-list";
import {LocationsListPage} from "../locations-list/locations-list";
import {LoginPage} from "../login/login";
import {ReceiveStockPopupPage} from "../receive-stock-popup/receive-stock-popup";
import {LocationCodeModelPage} from "../location-code-model/location-code-model";
import {ThankYouModalPage} from "../thank-you-modal/thank-you-modal";
import {LicenseStatusModelPage} from "../license-status-model/license-status-model";
import {SearchPage} from "../search/search";
import {CustomerWishListPage} from "../customer-wish-list/customer-wish-list";
import {BarcodeScanner} from "ionic-native";
import {ItemsPage} from "../items/items";
import {MyOrderPage} from "../my-order/my-order";
import {ItemPage} from "../item-details/item-details";
import {MarkBadProductModelPage} from "../mark-bad-product-model/mark-bad-product-model";
import {BadstockcartManager} from "../../providers/badstockcart-manager";
import {ManageBadProductLocationsPage} from "../manage-bad-product-locations/manage-bad-product-locations";
import {ManageBadProductModelPage} from "../manage-bad-product-model/manage-bad-product-model";
import {PurgeInventoryModelPage} from "../purge-inventory-model/purge-inventory-model";

@Component({
  selector: 'page-bad-inventory',
  templateUrl: 'bad-inventory.html',
})
export class BadInventoryPage {
  isWebstore = 0;
  isOfflineMode:any = false;

  public constants = Constants;
  public multipleCarts = false;
  public cart: any;
  public TotalPrice:number = 0;
  public TotalPriceBeforeTax:number = 0;
  baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;
  public barCodeFocus = "Keep focus here to scan QR/Scan Code.";
  @ViewChild('barcodeFocus') barCodeFocusInput ;
  @ViewChild(Content) content: Content;
  taxPercent = 0; // changed from  0.13
  TAX = 0;
  public locationSelected = 0;
  haveTitle:boolean = false;
  cartTitleTemp:string = "";
  orderStatus:number;
  cacheImages:any;
  quantity: any;
  updateButtonStatus = true;
  loggedInUserWarehouse = loginUserInfo.assignedWarehouseName
  reference = null;
  productLocation = "";
  referenceStatus = true;
  referenceTypeCheck = true;

  items = [];

  resultsAvailable: boolean = false;
  results: string[] = [];
  ignoreNextChange: boolean = false;
  locationPopUpOpenStatus: boolean = false;

  locationStatus = true;
  badProductConditionsList = [];

  purgeToggleStatus = false;

  constructor(
    public nav: NavController,
    private stockCartManager: BadstockcartManager,
    public http: Http,
    public api:Api,
    public toastCtrl:ToastController,
    public menuController:MenuController,
    public alertCtrl: AlertController,
    public menu:MenuController,
    public customerCarts:CustomerCarts,
    public events:Events,
    private gVLogger:GVLogger,
    private msgManager:MsgManager,
    private modalController:ModalController,
    private apiOffline:ApiOffline,
    private storage:Storage,
    private file: File,
    private modalCtrl:ModalController,
    private cartManager:CartManager
  ) {

    this.getLookupBadProductConditions();

    try{
      if(this.reference.trim() === ""){
        this.reference = null;
      }

    }catch(err){
      this.gVLogger.log("errrrroeerrrrrr : " + err);

    }

    if(this.reference != "" && this.reference != null){
      this.referenceStatus = false;
    }


    this.storage.get("cacheImages").then((cache)=>{
      this.cacheImages = cache;
    });

    this.isOfflineMode = ApplicationVariables.isOffline;

    if(Constants.isWebstore){
      this.isWebstore = 1;
    }

    this.cart = BADSTOCKCART;
    if(REFERENCE.productsreference != "" || REFERENCE.productsreference != null){
      this.gVLogger.log("reference in the dta file : " + JSON.stringify(REFERENCE));
      this.reference = REFERENCE.productsreference;
      this.referenceStatus = false;
    }

    if(REFERENCE.productsreference == "" || REFERENCE.productsreference == null){
      this.referenceStatus = true;
    }

    if(RECEIVESTOCKLOCATION.productsLocation != "" || RECEIVESTOCKLOCATION.productsLocation != null){
      this.gVLogger.log("location in the dta file : " + JSON.stringify(RECEIVESTOCKLOCATION));
      this.productLocation = RECEIVESTOCKLOCATION.productsLocation;
    }
    // this.stockCartManager.removeJunkFromCart();

    this.orderStatus = this.stockCartManager.getOrderStatus();
    this.cartTitleTemp = this.stockCartManager.getOrderTitle();

    this.events.publish("titleChange");

    if(this.cartTitleTemp != ""){
      this.haveTitle = true;
    }

    this.events.subscribe("titleChange" ,()=>{
      this.gVLogger.log(this.stockCartManager.getOrderTitle());
      this.cartTitleTemp = this.stockCartManager.replaceDoublePipe(this.stockCartManager.getOrderTitle());
      // this.gVLogger.log("title changed : " ,this.cartTitleTemp);
      if(this.cartTitleTemp == ""){
        this.haveTitle = false;
      }else{
        this.haveTitle = true;
      }
    });

    this.refreshTotalPrice();
    this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
    this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;

    if(!Constants.isWebstore && !ApplicationVariables.isOffline){
      this.getCustomerCarts(0);
    }

    this.updateButtonStatus = true;

    this.events.subscribe("cartUpdated",()=>{
      this.refreshTotalPrice();
    });

  }




  initializeItemsOnFocus() {

    if(this.referenceStatus === true){
      this.referenceStatus = false;
      this.gVLogger.log(" iiiiteemmms in cart   " + this.cart.items.length);

      let ref = "";
      try{
        ref = this.reference.trim();
      }
      catch (e) {
        ref = null;
      }

      if(ref !== "" && ref !== null){
        this.api.get("products/getReferencNo/"+ref)
          .map(res => res.json())
          .subscribe(data => {

            if(data.status == "401"){ // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

              this.nav.setRoot(LoginPage);
            }
            if(data.status === "200"){
              this.items = [];
              for(let item of data.data){
                this.items.push(item.referenceNo);
                this.gVLogger.log("daaaattaaaaa : " + this.items);
              }

              let model = this.modalController.create(ReferenceListPage, {items: this.items});
              model.onDidDismiss(data => {
                this.gVLogger.log("data on dismiss : " + data);
                if(data !== "" && data != null){
                  this.reference = data;
                  this.stockCartManager.setReference(data);
                  this.referenceStatus = false;
                }
                else {
                  this.referenceStatus = true;
                }
              });
              model.present();

              this.items = [];
            }

          });
      }

      else if(this.cart.items.length < 1 && (ref === null || ref === "")){
        this.gVLogger.log("if extecuted in getReferencNo");
        let searchString = -1;
        this.api.get("products/getReferencNo/"+searchString)
          .map(res => res.json())
          .subscribe(data => {
            if(data.status == "401"){ // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

              this.nav.setRoot(LoginPage);
            }
            if(data.status === "200"){
              for(let item of data.data){
                this.items.push(item.referenceNo);
                this.gVLogger.log("daaaattaaaaa : " + item);
              }
              let model = this.modalController.create(ReferenceListPage, {items: this.items});
              model.onDidDismiss(data => {
                this.gVLogger.log("data on dismiss : " + data);
                if(data !== "" && data != null){
                  this.reference = data;
                  this.stockCartManager.setReference(data);
                  this.referenceStatus = false;
                }
                else {
                  this.referenceStatus = true;
                }
              });
              model.present();
              this.items = [];
            }

          });
      }

      else if (this.cart.items.length === 1 && (ref === null || ref === "")){
        this.gVLogger.log("if executed getproductReferencesByProductId");
        let searchString = this.cart.items[0].id;
        this.api.get("products/getproductReferencesByProductId/" + searchString)
          .map(res => res.json())
          .subscribe(data => {
            if(data.status == "401"){ // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

              this.nav.setRoot(LoginPage);
            }
            if (data.status === "200") {
              for (let item of data.data) {
                this.items.push(item);
                this.gVLogger.log("daaaattaaaaa : " + item);
              }

              let model = this.modalController.create(ReferenceListPage, {items: this.items});
              model.onDidDismiss(data => {
                this.gVLogger.log("data on dismiss : " + data);
                if(data !== "" && data != null){
                  this.reference = data;
                  this.stockCartManager.setReference(data);
                  this.referenceStatus = false;
                }
                else {
                  this.referenceStatus = true;
                }
              });
              model.present();

              this.items = [];
            }
          });
      }
    }
    else {
      this.msgManager.toastMsg("Not allowed! There are multiple products in cart.");
    }
  }



  getLocationsOnFocus() {

    if(this.locationPopUpOpenStatus == false){
      this.locationPopUpOpenStatus = true;
      this.gVLogger.log(" iiiiteemmms in cart   " + this.cart.items.length);

      let loc = "";

      loc = "-1";

      this.api.get("products/getLocationsByAdpCustomerId/?searchString="+ loc)
        .map(res => res.json())
        .subscribe(data => {
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          if(data.status === "200"){
            this.items = [];
            for(let item of data.data){
              this.items.push(item.locationCode);
              this.gVLogger.log("daaaattaaaaa : " + this.items);
            }

            let model = this.modalController.create(LocationsListPage, {items: this.items, searchString: loc});
            model.onDidDismiss(data => {
              this.gVLogger.log("data on dismiss : " + data);
              if(data !== "" && data != null){
                this.productLocation = data;
                this.stockCartManager.setLocation(data);

              }
              else {

              }
            });
            model.present();

            this.items = [];
          }

        });

      setTimeout(() => {
        this.locationPopUpOpenStatus = false;
      },500)


    }
    else{

    }
  }

  search(val){
    this.gVLogger.log("search called" + val);
  }

  removeFocus(){
    this.gVLogger.log("remove focus called");
  }

  ionViewDidLoad(){

    setTimeout(() => {
      // Keyboard.show() // for android
      if(!Constants.isWebstore){
        // alert("sada");
        this.barCodeFocusInput.setFocus();
      }
    },800); //a least 150ms.
    //  this.gVLogger.log("Ion view loaded");
  }


  checkReferenceTypeOfCartProducts(){
    this.gVLogger.log("callllllleddd : " + this.cart.items.length);
    if(this.stockCartManager.getProductsCount() < 1){
      this.referenceStatus = true;
    }
    for(let item of this.cart.items){
      if(item.referenceNumber != "" && this.stockCartManager.getProductsCount() >= 1){
        this.gVLogger.log("if callllllleddd : " + this.stockCartManager.getProductsCount());
        this.referenceStatus = false;
        return;
      }
      else{
        this.gVLogger.log("else callllllleddd : " + this.stockCartManager.getProductsCount());
        this.referenceStatus = true;
      }
    }

  }

  updateProductInCart(product){
    if(String(product.quantity) !=""){
      if(String(product.quantity).match(/^\d+$/)){
        this.stockCartManager.updateCartNew(product);
      }else{
        product.quantity = Number(product.quantity);
        this.stockCartManager.updateCartNew(product);
      }
    }else{
      product.quantity = Number(product.quantity);
      this.stockCartManager.updateCartNew(product);
    }
    this.refreshTotalPrice();

  }


  selectAll(event){
    event.target.select();
  }



  addFromBarCode(event){
    event.target.value = event.target.value.trim();
    setTimeout(()=>{
      let barCode=event.target.value;
      if(event.target.value !== ""){

        this.api.get("products/getLocationAgainstProductBarCode/"+barCode)

          .map(res => res.json())
          .subscribe(data => {

            if (data.status == "401") { // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
              setTimeout(() => {
                event.target.value = "";
                event.target.focus();
              }, 500)

              this.nav.setRoot(LoginPage);
            } else if (data.status === "200")
            {
              let locationArray = [];
              for (let obj of data.data){
                locationArray.push(obj.inventoryLocationById);
              }

              let model = this.modalController.create(ManageBadProductLocationsPage, {items: locationArray});
              model.onDidDismiss(dataa => {
                if (dataa !== "" && dataa != null){

                  this.api.get("products/getProductQuantitiesOnLocation/?barcode="+barCode+"&productLocationId="+dataa.id)

                    .map(res => res.json())
                    .subscribe(data => {

                      if (data.status == "401") { // check for session out
                        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
                        setTimeout(() => {
                          event.target.value = "";
                          event.target.focus();
                        }, 500)

                        this.nav.setRoot(LoginPage);
                      }
                      else if (data.status === "200") {

                        this.gVLogger.log("Locations data 200 : " + data.data);

                        if (data.data.length <= 0){
                          this.msgManager.toastMsg("No product received with  Barcode: " + barCode + "!");
                          setTimeout(()=>{
                            event.target.value = "";
                            event.target.focus();
                          },500)
                        }


                        for (let product of data.data) {
                          product.productLocationIdWithCode = product.id + product.productInventoryLocationsDTO[0].inventoryLocationById.locationCode + product.productInventoryLocationsDTO[0].productConditionCode + product.productInventoryLocationsDTO[0].lotNumber;
                          for(let loc of product.productInventoryLocationsDTO){
                            loc.quantityReceived = loc.quantityRemaining;
                          }

                          this.addProductToCart(product);
                          this.scrollBottom();
                          event.target.value = "";
                          event.target.focus();
                        }


                      }else if(data.status == "404"){

                        this.msgManager.toastMsg("No product found with  Barcode: " + barCode + "!");
                        setTimeout(()=>{
                          event.target.value = "";
                          event.target.focus();
                        },500)

                      }

                });
                }else {
                  this.msgManager.toastMsg("Please select one location!");
                }
              });
              model.present();


            }else if(data.status == "404"){

              this.msgManager.toastMsg("No product found with  Barcode: " + barCode + "!");
              setTimeout(()=>{
                event.target.value = "";
                event.target.focus();
              },500)

            }
          });
        setTimeout(()=>{
          event.target.value = "";
          event.target.focus();
        },500);
      }
    },400);

    setTimeout(()=>{
      event.target.value = "";
      event.target.focus();
    },500);
    this.scrollBottom();
  }

  getLookupBadProductConditions(){
    this.api.get("lookup/codesByTable?tableName=badProductConditions").map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.badProductConditionsList = result.data;
      }else if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }
    });

  }

  presentThankYouAlert(title,msg){
    let thankyouModal = this.modalCtrl.create(ThankYouModalPage, { title: title ,message: msg });
    thankyouModal.present();
  }

  presentPaySatusAlert(title,msg){
    this.gVLogger.log("LicenseStatusModelPage");
    let thankyouModal = this.modalCtrl.create(LicenseStatusModelPage, { title: title ,message: msg });
    thankyouModal.present();
  }


  holdCart(){
    this.gVLogger.log("Location : " + this.productLocation);
    this.updateButtonStatus = false;
    this.gVLogger.log("update button status : " + this.updateButtonStatus);
    if(Number(this.stockCartManager.getProductsCount()) < 1){
      this.msgManager.toastMsg("Can't save empty list.");
      setTimeout(() => {
        this.updateButtonStatus = true;
      }, 2000)
      return null;
    }

    var body:any = this.stockCartManager.receiveStock(100, this.reference, location); // status 100 for Stock Reading

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({
      headers: headers
    });




          this.api.post("products/manageBadStock",JSON.stringify(body), options)
            .map(res => res.json())
            .subscribe(resp => {
                if(resp.status="200"){
                  this.msgManager.toastMsg("Inventory is successfully updated!");
                  this.ionViewDidLoad();
                  this.stockCartManager.clearCart();
                  // this.refreshTotalPrice();
                  // this.stockCartManager.setOrderTitle("");
                  this.events.publish("titleChange");

                }else if(resp.status == 401){ // check for session out
                  this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                  this.nav.setRoot(LoginPage);
                }
                else{
                  this.msgManager.toastMsg(this.msgManager.getWentWrongMsg());
                }



              }
              , error =>{
                // this.gVLogger.log("update call failed");
              });

          setTimeout(() => {
            this.updateButtonStatus = true;
          }, 2000)


  }


  purgrInventoryCart(){
    this.gVLogger.log("Location : " + this.productLocation);
    this.updateButtonStatus = false;
    this.gVLogger.log("update button status : " + this.updateButtonStatus);
    if(Number(this.stockCartManager.getProductsCount()) < 1){
      this.msgManager.toastMsg("Can't save empty list.");
      setTimeout(() => {
        this.updateButtonStatus = true;
      }, 2000)
      return null;
    }

    let userName = "";

    this.storage.get("userName").then((data) =>{

      userName = data;
      // commentLine = btoa(data + ": " + badPro.comment);
      // // badPro.comment = btoa(data + ": " + badPro.comment);
      console.log("UUUUUUUUUUUUU : " + userName)

    })
    var body:any = this.stockCartManager.receiveStock(100, this.reference, location); // status 100 for Stock Reading

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({
      headers: headers
    });




    this.api.post("products/purgeBadInventory",JSON.stringify(body), options)
      .map(res => res.json())
      .subscribe(resp => {
          if(resp.status="200"){
            // this.msgManager.toastMsg("Inventory is successfully purged!");
            this.msgManager.toastMsg(resp.message);
            this.ionViewDidLoad();
            this.stockCartManager.clearCart();
            // this.refreshTotalPrice();
            // this.stockCartManager.setOrderTitle("");
            this.events.publish("titleChange");

          }else if(resp.status == 401){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          else{
            this.msgManager.toastMsg(this.msgManager.getWentWrongMsg());
          }



        }
        , error =>{
          // this.gVLogger.log("update call failed");
        });

    setTimeout(() => {
      this.updateButtonStatus = true;
    }, 2000)


  }

  totalQuantityPlacedOnLocation(product){
    let totalQuantity = 0;
    for(let loc of product.productInventoryLocationsDTO){
      // this.gVLogger.log("Quantity TTTTTTTTTTTTTTTT " + loc.quantityRemaining);
      totalQuantity += loc.quantityRemaining;
    }

    return totalQuantity;
  }

  totalBad(product){
    let totalQuantity = 0;
    console.log("Locationnnnnnnnnnnnnn : " + JSON.stringify(product.productInventoryLocationsDTO));
    for(let loc of product.productInventoryLocationsDTO){
      if(loc.productConditionCode !== 0){
        if(parseInt(loc.quantityReceived) !== NaN && parseInt(loc.quantityReceived) !== undefined) {
          let integerQuantityReceived = parseInt(loc.quantityReceived);
          totalQuantity += integerQuantityReceived;
        }
      }

    }

    return totalQuantity;
  }


  // go to search page
  goToSearch() {
    this.menuController.close("testRightMenu");
    this.nav.push(SearchPage);
  }
  goToCustomerWishList(){
    this.nav.push(CustomerWishListPage);
  }

  refreshTotalPrice(){
    this.cart = BADSTOCKCART;
    let temp:number = 0;
    for(let item of this.cart.items){
      temp =  temp +  Number(item.quantity);
    }
    this.TotalPriceBeforeTax =  Number(temp.toFixed(2));
    this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
    this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;
    //alert(JSON.stringify(this.cart));
  }

  addProductToCart(item){
    this.stockCartManager.addProductToCart(item);
    this.refreshTotalPrice();
    return true;
  }

  removeProductFromCart(product){

    this.stockCartManager.removeOneNew(product);

    this.refreshTotalPrice();
  }


  cameraBarcodeScanner(){

    this.gVLogger.log("Camera barcode Scanner");
    BarcodeScanner.scan().then((barcodeData) => {
      this.msgManager.startLoading();

      if (!barcodeData.cancelled) {

        this.api.get("/products/barcode/"+barcodeData.text+"?isWebStore="+this.isWebstore)
          .map(res => res.json())
          .subscribe(data => {

            this.msgManager.stopLoading();
            if(data.status == "401"){ // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

              this.nav.setRoot(LoginPage);
            }else if(data.status == 200){
              if(data.data.id != 0){
                this.stockCartManager.addProductToCart(data.data);
              }

            }
          }, (err)=>{
            this.msgManager.stopLoading();
          });

      }else{
        this.msgManager.stopLoading();
      }


    }, (err) => {
      this.msgManager.stopLoading();

    });

  }


  deleteProductFromCart(product){

    this.gVLogger.log("detete caled....");
    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      message: "Are you sure you want to delete '"+product.name+"' from the cart?",
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            //  this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {
            // this.gVLogger.log('Agree clicked');
            this.stockCartManager.deleteProductFromCart(product);
            this.refreshTotalPrice();
            this.checkReferenceTypeOfCartProducts();
          }
        }
      ]
    });
    confirm.present();
  }
  clearCart(){
    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      message: 'You want to clear all the products from cart',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            //  this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {
            // this.gVLogger.log('Agree clicked');
            this.stockCartManager.clearCartProducts();
            this.refreshTotalPrice();
          }
        }
      ]
    });
    confirm.present();
  }

  onFocusBarcode(event){
    event.target.value = "";
    this.barCodeFocus = "Scanner ACTIVE";

  }
  onBlurBarcode(event){
    event.target.value = "";

    this.barCodeFocus = "Keep focus here to scan QR/Scan Code.";
  }


  onFocusLocation(event){
    event.target.value = "";
    this.barCodeFocus = "Scanner ACTIVE";

  }
  onBlurLocation(event){
    event.target.value = "";

    this.barCodeFocus = "Keep focus here to scan QR/Scan Code.";
  }

  activateBarcodeField(){
//this.gVLogger.log("activateBarcodeField Loaded");
    setTimeout(() => {
      // Keyboard.show() // for android
      this.barCodeFocusInput.setFocus();
    },0); //a least 150ms.
  }

  locationSelectedChange(event){
    //alert(this.locationSelected);
  }

  imageNotFound(e,item){
    item.productImagesDTO[0].extension = "png";
    item.productImagesDTO[0].name = "dummy";
  }

  discardCart(){// TODO: Check if order contains ID delete on Server else Delete local
    this.stockCartManager.setLocation("");
    this.stockCartManager.setReference("");
    if(Number(this.stockCartManager.getProductsCount()) < 1){
      this.msgManager.toastMsg("Can't reset empty list.");
      this.productLocation = "";
      this.referenceStatus = true;
      this.reference = "";
      return null;
      //UD

    }
    else{
      this.menu.close('testRightMenu');
      // alert(this.stockCartManager.getProductsCount());
      let confirm = this.alertCtrl.create({
        title: 'Are you sure?',
        message: 'You want to discard this Cart',
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
              //  this.gVLogger.log('Disagree clicked');
            }
          },
          {
            text: 'Agree',
            handler: () => {
              // this.gVLogger.log('Agree clicked');
              this.reference = "";
              this.productLocation = "";
              this.referenceStatus = true;

              if(this.stockCartManager.getOrderId() == 0){
                this.gVLogger.log("Local Order");
                this.stockCartManager.clearCartProducts();
                this.stockCartManager.setOrderTitle("");
                this.events.publish("titleChange");
                this.stockCartManager.setOrderId(0);
                this.refreshTotalPrice();
                this.getCustomerCarts(0);
                this.stockCartManager.setLocation("");
                this.stockCartManager.setReference("");

              }else{
                // TODO: send call to server

                let body = "?orderId="+this.stockCartManager.getOrderId()+"&customerId="+this.stockCartManager.getSalesManId();

                this.api.post("order/discard"+body,null).map(res => res.json()).subscribe(result=>{
                  if(result.status == 200){
                    this.stockCartManager.clearCartProducts();
                    this.stockCartManager.setOrderTitle("");
                    this.stockCartManager.setOrderId(0);
                    this.refreshTotalPrice();
                    this.getCustomerCarts(0);
                    this.stockCartManager.setLocation("");
                    this.stockCartManager.setReference("");

                  }else if(result.status == "401"){ // check for session out
                    this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                    this.nav.setRoot(LoginPage);
                  }
                });

              }

            }
          }
        ]
      });
      confirm.present();
    }
  }



  scrollBottom(){
    setTimeout(()=>{
      this.content.scrollToBottom(200);
    },400)

  }
  scrollToItem(yOffset){
    this.content.scrollTo(0, yOffset, 200);
  }

  toggleRignt(){

    this.menu.toggle('testRightMenu');
  }

  getCustomerCarts(startPoint){


    let body = "?customerId="+this.stockCartManager.getCustomerID()+"&startPoint="+startPoint;
    this.api.post("order/loadByCustomer"+body,null)
      .map(res => res.json())
      .subscribe(data => {
        if(data.status == 200){

          this.customerCarts.setCustomerCarts(data.data);
          let cartsOnhold:number = 0;
          for(let cart of data.data){
            if(cart.orderStatus == 100) {
              cartsOnhold += 1;
            }
          }
          //  this.gVLogger.log(data);
          if(cartsOnhold > 0){
            this.multipleCarts = true;
          }
        }else if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        }else {
          this.msgManager.toastMsg(data.message);
        }
      });
  }


  discountCheck(discountPrice){
    // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }


  getNumber(val: any) {
    if (isNaN(val)) return 0;
    return +val;
  }

  decimalLengthFixed(num,max){
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }


  gotoItemsPage(){
    this.nav.setRoot(ItemsPage);
  }

  gotoOrdersPage(){
    this.nav.setRoot(MyOrderPage);
  }
  logOut(){
    this.nav.setRoot(LoginPage);
  }

  gotoSingleView(product){
    this.api.get("product/" + product.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }
      if(data.status === "200"){
        product.description = data.data.description;
      }
    })
    this.nav.push(ItemPage, {item: product, "status" : "fromReceiveStock"});
  }

  holdCartResolver(){
    this.gVLogger.log("update button status in hold cart " +  this.updateButtonStatus);
    this.updateButtonStatus = false;
    this.gVLogger.log("update button status in hold cart " + this.updateButtonStatus);
    if (this.isOfflineMode) {
      this.holdOrderOffline();
    }else{
      this.holdCart();
    }
  }


  holdOrderOffline(){


    if(Number(this.stockCartManager.getProductsCount()) < 1){
      this.msgManager.toastMsg("Can't Save empty list.");
      return null;
    }


    if(!Constants.isWebstore && this.stockCartManager.getOrderTitle() == "" ){
      let prompt = this.alertCtrl.create({
        title: 'Please enter stock location info',
        inputs: [
          {
            name: 'location',
            placeholder: 'Name or Location'
          },
          {
            name: 'aisle',
            placeholder: 'Aisle'
          },
          {
            name: 'shelf',
            placeholder: 'Shelf'
          },
          {
            name: 'bin',
            placeholder: 'Bin'
          },
        ],
        buttons: [
          {
            text: 'Cancel',
            handler: data => {
              //  this.gVLogger.log('Cancel clicked');
            }
          },
          {
            text: 'Save',
            handler: data => {
              this.stockCartManager.setOrderTitle(data.location + "||" + data.aisle + "||" + data.shelf + "||" + data.bin);

              var body:any = this.stockCartManager.genrateOrder(100); // status 100 for Stock reading

              this.apiOffline.insertOrder(JSON.stringify(body))
                .then((data) => {
                  this.stockCartManager.clearCart();
                  this.stockCartManager.setOrderTitle("");
                  this.events.publish("titleChange");
                  this.stockCartManager.setOrderMessage("");
                  this.stockCartManager.setOrderId(0);
                  this.stockCartManager.setOrderStatus(0);
                  this.refreshTotalPrice();
                  // this.nav.setRoot(ItemsPage);
                  this.getCustomerCarts(0);

                })
                .catch(e => this.gVLogger.log(e));

            }
          }
        ]
      });
      prompt.present();
    }else{



      var body:any = this.stockCartManager.genrateOrder(100); // status 100 for Stock readiung

      this.apiOffline.insertOrder(JSON.stringify(body))
        .then((data) => {

          this.stockCartManager.clearCart();
          this.stockCartManager.setOrderTitle("");
          this.stockCartManager.setOrderMessage("");
          this.events.publish("titleChange");
          this.stockCartManager.setOrderId(0);
          this.stockCartManager.setOrderStatus(0);
          this.refreshTotalPrice();
          this.events.publish("titleChange");
          // this.nav.setRoot(ItemsPage);
          this.getCustomerCarts(0);

        })
        .catch(e => this.gVLogger.log(e));
    }


  }

  // makeImageURL(dimensions,item){
  //   return this.stockCartManager.makeImageURL(dimensions,item);
  // }


  makeImageURL(dimensions,item){
    if(item.productImagesDTO[0].name === "dummy" || item.productImagesDTO[0].name === "dummy"){
      if(this.constants.isWebstore){
        return this.cartManager.makeNANImageURLFromImage(dimensions);
      }
      else{
        return "./assets/img/dummy-"+dimensions+".png";
      }
    }else{
      this.gVLogger.log("UUUUUUUURRRRRrl " + this.cartManager.makeImageURL(dimensions,item));
      return this.cartManager.makeImageURL(dimensions,item);
    }
  }


  getCSVFromCARTItems(){

    let temp =  this.cart.items.map((o)=>{ return {id:o.id,Name:o.name,Quantity:o.quantity,barcode:o.barCode}});


    return this.stockCartManager.ConvertToCSV(temp);

  }

  emailCSV(){


    // /intelliStock/emailService

    let temp = this.stockCartManager.getOrderTitle().split("||");

    let location = temp[0];
    let aisle = temp[1];
    let shelf = temp[2];
    let bin = temp[3];

    let prompt = this.alertCtrl.create({
      title: 'Please enter stock location info',
      inputs: [
        {
          name: 'location',
          placeholder: 'Name or Location',
          value: location
        },
        {
          name: 'aisle',
          placeholder: 'Aisle',
          value: aisle
        },
        {
          name: 'shelf',
          placeholder: 'Shelf',
          value: shelf
        },
        {
          name: 'bin',
          placeholder: 'Bin',
          value: bin
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            //  this.gVLogger.log('Cancel clicked');
          }
        },
        {
          text: 'Email',
          handler: data => {
            //  this.gVLogger.log(data.title);
            // this.cartManager.setOrderTitle(data.title);
            this.stockCartManager.setOrderTitle(data.location + "||" + data.aisle + "||" + data.shelf + "||" + data.bin);

            var body:any = this.stockCartManager.genrateOrder(100); // status 100 for Stock reading

            let headers = new Headers({
              'Content-Type': 'application/json'
            });
            let options = new RequestOptions({
              headers: headers
            });
            this.api.post("order/place",JSON.stringify(body), options)
              .map(res => res.json())
              .subscribe(resp => {

                this.api.postJazzba('intelliStock/emailService',{
                  email: this.stockCartManager.getSalesPerson().email,
                  subject:this.stockCartManager.replaceDoublePipe(this.stockCartManager.getOrderTitle()),
                  fileText: this.getCSVFromCARTItems(),
                  filename:"StockReading",

                })
                  .map(res=>res.json())
                  .subscribe((result)=>{
                    if(result.status == 200){
                      this.stockCartManager.clearCart();
                      this.stockCartManager.setOrderTitle("");
                      this.events.publish("titleChange");
                      this.stockCartManager.setOrderMessage("");
                      this.stockCartManager.setOrderId(0);
                      this.stockCartManager.setOrderStatus(0);
                      this.refreshTotalPrice();

                      this.api.toastMSG(result.message);

                    }else{
                      this.api.toastMSG(result.message);
                    }
                  }, (error)=>{
                    this.gVLogger.log(error);
                  })



                // this.nav.setRoot(ItemsPage);
                this.getCustomerCarts(0);

              })

          }
        }
      ]
    });
    prompt.present();


    // this.file.writeFile(this.file.applicationDirectory, 'test.csv', this.getCSVFromCARTItems(), {replace: true})
    //    .then(() => {
    //      alert("File saved");
    //      let email = {
    //        to: 'gsn.ahmad@gmail.com',
    //        attachments: [
    //          this.file.applicationDirectory + 'test.csv'
    //        ],

    //        subject: 'Test',
    //        body: 'CSV test email...',
    //        isHtml: true
    //      };
    //      this.emailComposer.open(email);

    //    })
    //    .catch((err) => {
    //      alert(JSON.stringify(err));
    //    });

  }

  saveAsCsv() {
    var blob = new Blob([this.getCSVFromCARTItems()]);
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = "newdata.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }


  checkLocationCodeExist(){
    this.updateButtonStatus = false;
    this.gVLogger.log("checkLocationCodeExist called");

    let location = this.productLocation.trim();

    // else{
    // this.api.get("/inventory/checkIfLocationExist?locationCode="+ this.productLocation)
    //   .map(res => res.json())
    //   .subscribe(data => {
        if(location === ""){
          let locationModel = this.modalCtrl.create(LocationCodeModelPage, {title: "Empty Location!", message: "The location field cannot be left empty. Please enter a valid location."});
          locationModel.present();
          // this.msgManager.toastMsg("Location should not empty!");
          setTimeout(() => {
            this.updateButtonStatus = true;
          }, 2000)
        }

        else {
          this.holdCartResolver();
        }
        // else if(data.status === "401"){
        //   let locationModel = this.modalCtrl.create(LocationCodeModelPage, {title: "Invalid Location!", message: "The location you entered is not matching any location defined in the system. Please enter a valid location."});
        //   locationModel.present();
        //   setTimeout(() => {
        //     this.updateButtonStatus = true;
        //   }, 2000)
        // }
        // else{
        //   this.gVLogger.log("Status is some thing else than 200 and 401 in location check");
        //   setTimeout(() => {
        //     this.updateButtonStatus = true;
        //   }, 2000)
        // }
      // });
  }

  chooseFromLocations(product){
    this.gVLogger.log("LicenseStatusModelPage" +  product);
    let backup = JSON.stringify(product);
    this.gVLogger.log("LicenseStatusModelPageeeee" +  this.cart);
    // this.api.get("/products/getLocationAgainstProductIdAndLocationId/" + product.id + "/" + product.productInventoryLocationsDTO[0].inventoryLocationById.id
    // ).map(res => res.json()).subscribe(data => {
    //   this.gVLogger.log("data from /products/getProductsForPickShip : " + data);
    //   if(data.status === "200"){

    let productLocationsModel = this.modalCtrl.create(ManageBadProductModelPage, {item: product}, {cssClass: 'receiceStockModall'});
    productLocationsModel.onDidDismiss(dataFromMarkBadProductModel => {
      // this.gVLogger.log("Data from product location model in pickpack list : " + dataFromProductLocationsModel);


      // if(dataFromMarkBadProductModel !== null && dataFromMarkBadProductModel !== undefined){
      //
      //   this.gVLogger.log("Data from product location model in pickpack list : " + JSON.stringify( dataFromMarkBadProductModel));
      //   product.badProductDtoList = dataFromMarkBadProductModel;
      //   // this.totalQuantityOfSelectedProducts();
      // }
    })
    productLocationsModel.present();
    // }
    // });

  }


  chooseFromLocationsForPurge(product){
    this.gVLogger.log("LicenseStatusModelPage" +  product);
    let backup = JSON.stringify(product);
    this.gVLogger.log("LicenseStatusModelPageeeee" +  this.cart);
    // this.api.get("/products/getLocationAgainstProductIdAndLocationId/" + product.id + "/" + product.productInventoryLocationsDTO[0].inventoryLocationById.id
    // ).map(res => res.json()).subscribe(data => {
    //   this.gVLogger.log("data from /products/getProductsForPickShip : " + data);
    //   if(data.status === "200"){

    let productLocationsModel = this.modalCtrl.create(PurgeInventoryModelPage, {item: product}, {cssClass: 'receiceStockModall'});
    productLocationsModel.onDidDismiss(dataFromMarkBadProductModel => {
      // this.gVLogger.log("Data from product location model in pickpack list : " + dataFromProductLocationsModel);


      // if(dataFromMarkBadProductModel !== null && dataFromMarkBadProductModel !== undefined){
      //
      //   this.gVLogger.log("Data from product location model in pickpack list : " + JSON.stringify( dataFromMarkBadProductModel));
      //   product.badProductDtoList = dataFromMarkBadProductModel;
      //   // this.totalQuantityOfSelectedProducts();
      // }
    })
    productLocationsModel.present();
    // }
    // });

  }

  onChangePurgeStatus(){

    this.stockCartManager.setLocation("");
    this.stockCartManager.setReference("");
    if(Number(this.stockCartManager.getProductsCount()) < 1){
      // this.msgManager.toastMsg("Can't reset empty list.");
      if(this.purgeToggleStatus === true){
        this.purgeToggleStatus = false;
      }else {
        this.purgeToggleStatus = true;
      }

      this.productLocation = "";
      this.referenceStatus = true;
      this.reference = "";
      return null;
      //UD

    }
    else{
      this.menu.close('testRightMenu');
      // alert(this.stockCartManager.getProductsCount());
      let confirm = this.alertCtrl.create({
        title: 'Are you sure?',
        message: 'Cart will be discarted!',
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
              //  this.gVLogger.log('Disagree clicked');
            }
          },
          {
            text: 'Agree',
            handler: () => {
              // this.gVLogger.log('Agree clicked');
              if(this.purgeToggleStatus === true){
                this.purgeToggleStatus = false;
              }else {
                this.purgeToggleStatus = true;
              }

              this.reference = "";
              this.productLocation = "";
              this.referenceStatus = true;

              // if(this.stockCartManager.getOrderId() == 0){
                this.gVLogger.log("Local Order");
                this.stockCartManager.clearCartProducts();
                this.stockCartManager.setOrderTitle("");
                this.events.publish("titleChange");
                this.stockCartManager.setOrderId(0);
                this.refreshTotalPrice();
                this.getCustomerCarts(0);
                this.stockCartManager.setLocation("");
                this.stockCartManager.setReference("");

              // }else{
              //   // TODO: send call to server
              //
              //   let body = "?orderId="+this.stockCartManager.getOrderId()+"&customerId="+this.stockCartManager.getSalesManId();
              //
              //   this.api.post("order/discard"+body,null).map(res => res.json()).subscribe(result=>{
              //     if(result.status == 200){
              //       this.stockCartManager.clearCartProducts();
              //       this.stockCartManager.setOrderTitle("");
              //       this.stockCartManager.setOrderId(0);
              //       this.refreshTotalPrice();
              //       this.getCustomerCarts(0);
              //       this.stockCartManager.setLocation("");
              //       this.stockCartManager.setReference("");
              //
              //     }else if(result.status == "401"){ // check for session out
              //       this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
              //
              //       this.nav.setRoot(LoginPage);
              //     }
              //   });
              //
              // }

            }
          }
        ]
      });
      confirm.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/bad-inventory/bad-inventory.ts